import openingCenterImage from '../assets/opening-center.svg';
import openingColumnLeftImage from '../assets/opening-column-left.svg';
import openingColumnRightImage from '../assets/opening-column-right.svg';
import openingHalfImage from '../assets/opening-half.svg';
import parallaxTextCenterImage from '../assets/parallax-text-center.svg';
import parallaxTextLeftImage from '../assets/parallax-text-left.svg';
import parallaxTextRightImage from '../assets/parallax-text-right.svg';
import parallaxTextColumnLeftImage from '../assets/parallax-text-column-left.svg';
import parallaxTextColumnRightImage from '../assets/parallax-text-column-right.svg';
import multimediaImage from '../assets/multimedia.svg';
import parallaxImage from '../assets/parallax-image.svg';
import ScrollytellingSlideEditorFormOpening from '@/modules/scrollytelling/components/form/ScrollytellingSlideEditorFormOpening';
import ScrollytellingSlideEditorFormMultimedia from '@/modules/scrollytelling/components/form/ScrollytellingSlideEditorFormMultimedia';
import ScrollytellingSlideEditorFormHtml from '@/modules/scrollytelling/components/form/ScrollytellingSlideEditorFormHtml';
import ScrollytellingSlideEditorFormParallaxImage from '@/modules/scrollytelling/components/form/ScrollytellingSlideEditorFormParallaxImage';
import ScrollytellingSlideEditorFormParallaxText from '@/modules/scrollytelling/components/form/ScrollytellingSlideEditorFormParallaxText';

export const SLIDE_TYPE_OPENING = 'opening';
export const SLIDE_TYPE_MULTIMEDIA = 'multimedia';
export const SLIDE_TYPE_PARALLAX_TEXT = 'parallax-text';
export const SLIDE_TYPE_PARALLAX_IMAGE = 'parallax-image';
export const SLIDE_TYPE_HTML = 'html';

export const availableSlideTypes = [
  {
    type: SLIDE_TYPE_OPENING,
    formComponent: ScrollytellingSlideEditorFormOpening,
  },
  {
    type: SLIDE_TYPE_MULTIMEDIA,
    formComponent: ScrollytellingSlideEditorFormMultimedia,
  },
  {
    type: SLIDE_TYPE_PARALLAX_TEXT,
    formComponent: ScrollytellingSlideEditorFormParallaxText,
  },
  {
    type: SLIDE_TYPE_PARALLAX_IMAGE,
    formComponent: ScrollytellingSlideEditorFormParallaxImage,
  },
  {
    type: SLIDE_TYPE_HTML,
    formComponent: ScrollytellingSlideEditorFormHtml,
  },
];

const commonDefaultFields = {
  active: true,
};

export const allowedOpeningSlideTypes = [
  SLIDE_TYPE_OPENING,
];

export const availableSlideWizardTemplates = [
  {
    name: 'opening-center',
    type: SLIDE_TYPE_OPENING,
    image: openingCenterImage,
    defaultFields: {
      ...commonDefaultFields,
      textPosition: 'center',
      textVerticalPosition: 'center',
    },
  },
  {
    name: 'opening-column-left',
    type: SLIDE_TYPE_OPENING,
    image: openingColumnLeftImage,
    defaultFields: {
      ...commonDefaultFields,
      textPosition: 'left',
      textVerticalPosition: 'center',
      backgroundPosition: 'right-column',
    },
  },
  {
    name: 'opening-column-right',
    type: SLIDE_TYPE_OPENING,
    image: openingColumnRightImage,
    defaultFields: {
      ...commonDefaultFields,
      textPosition: 'right',
      textVerticalPosition: 'center',
      backgroundPosition: 'left-column',
    },
  },
  {
    name: 'opening-half',
    type: SLIDE_TYPE_OPENING,
    image: openingHalfImage,
    defaultFields: {
      ...commonDefaultFields,
      textPosition: 'center',
      textVerticalPosition: 'center',
      backgroundPosition: 'half',
    },
  },
  {
    name: 'multimedia',
    type: SLIDE_TYPE_MULTIMEDIA,
    image: multimediaImage,
    defaultFields: {
      ...commonDefaultFields,
    },
  },
  {
    name: 'parallax-text-center',
    type: SLIDE_TYPE_PARALLAX_TEXT,
    image: parallaxTextCenterImage,
    defaultFields: {
      ...commonDefaultFields,
      textPosition: 'center',
      textAlign: 'left',
      multimediaPosition: 'none',
      transition: false,
    },
  },
  {
    name: 'parallax-text-left',
    type: SLIDE_TYPE_PARALLAX_TEXT,
    image: parallaxTextLeftImage,
    defaultFields: {
      ...commonDefaultFields,
      textPosition: 'left',
      textAlign: 'left',
      multimediaPosition: 'right',
      transition: false,
    },
  },
  {
    name: 'parallax-text-right',
    type: SLIDE_TYPE_PARALLAX_TEXT,
    image: parallaxTextRightImage,
    defaultFields: {
      ...commonDefaultFields,
      textPosition: 'right',
      textAlign: 'left',
      multimediaPosition: 'left',
      transition: false,
    },
  },
  {
    name: 'parallax-text-column-left',
    type: SLIDE_TYPE_PARALLAX_TEXT,
    image: parallaxTextColumnLeftImage,
    defaultFields: {
      ...commonDefaultFields,
      textPosition: 'left',
      textAlign: 'left',
      multimediaPosition: 'right',
      transition: false,
    },
  },
  {
    name: 'parallax-text-column-right',
    type: SLIDE_TYPE_PARALLAX_TEXT,
    image: parallaxTextColumnRightImage,
    defaultFields: {
      ...commonDefaultFields,
      textPosition: 'right',
      textAlign: 'left',
      multimediaPosition: 'left',
      transition: false,
    },
  },
  {
    name: 'parallax-image',
    type: SLIDE_TYPE_PARALLAX_IMAGE,
    image: parallaxImage,
    defaultFields: {
      ...commonDefaultFields,
      textPosition: 'center',
    },
  },
  {
    name: 'html',
    type: SLIDE_TYPE_HTML,
    image: multimediaImage,
    defaultFields: {
      ...commonDefaultFields,
    },
  },
];
